module.exports = __webpack_public_path__ + "img/romanian-choral-jewels.32b54fa1.jpeg";